import { Component, AfterViewInit, ElementRef } from '@angular/core';
import { CatalogSectionService } from './catalog-section.service';
import $ from './lib/jquery';
import UIkit from './lib/uikit';

@Component({
  selector: 'shop-slider',
  templateUrl: '../templates/shop-slider.component.html',
  styleUrls: ['../styles/components/shop-slider.component.less']
})
export class ShopSliderComponent implements AfterViewInit {

  constructor(
    public sectionService: CatalogSectionService,
    private el: ElementRef
  ) {}

  public async ngAfterViewInit() {
    if (typeof window !== 'undefined') {
      try {
        await this.sectionService.promise; // wait until sections load

        window.setTimeout(() => {
          const nativeEl = this.el.nativeElement;
          const headSlider = UIkit.slider(nativeEl.querySelector('.ShopSlider_Head > .uk-slider'), {finite: true});
          const contentSlider = UIkit.slider(nativeEl.querySelector('.ShopSlider_Content'), {finite: true});

          $(contentSlider.$el).on('itemshow', (e: JQueryEventObject) => {
            headSlider.show($(e.target).index());
          });

          $(headSlider.$el).on('itemshow', (e: JQueryEventObject) => {
            contentSlider.show($(e.target).index());
          });
        }, 100);
      } catch (e) {}
    }
  }

}
